import React from "react";
import TableViewPage from "./TableViewPage";
import danniNSI from "../assets/excel/Danni_NSI_2022.xlsx";

const DanniNSITablePage = () => {
  return (
    <TableViewPage
      excelFile={danniNSI}
      title="Кадри и образователна структура (НСИ)"
      headerRow={6}
      skipRows={1}
    />
  );
};

export default DanniNSITablePage;